<template>
  <v-toolbar flat color="white" density="compact">
    <v-toolbar-title class="text-primary">{{ label }}</v-toolbar-title>
  </v-toolbar>
  <v-divider/>
  <v-list v-if="files && files.length > 0" density="compact">
    <v-list-item v-for="(file, index) in files" :key="index" color="primary" class="ml-1">
      <v-list-item-title>
        <a class="sm-bold" @click="preview(file)">{{ file.name }}</a>
      </v-list-item-title>
      <v-list-item-subtitle>
        <span class="tiny-normal">{{ file.creator + ' on ' + moment(file.created_at).format("DD-MM-YYYY HH:mm") }}</span>
      </v-list-item-subtitle>
      <template v-if="deletable" #append>
        <v-list-item-action>
          <v-menu>
            <template #activator="{ props }">
              <v-btn elevation="0" icon v-bind="props">
                <PhDotsThreeVertical size="24" style="cursor: pointer;"/>
              </v-btn>
            </template>
            <v-list>
              <v-list-item @click="deleteFile(file)">
                <template #prepend><PhTrash size="24"/></template>
                <v-list-item-title class="sm-normal link ml-2">{{ $store.getters.translate('delete') }}</v-list-item-title>
              </v-list-item>
            </v-list>
          </v-menu>
        </v-list-item-action>
      </template>
    </v-list-item>
  </v-list>
  <div class="reg-normal text-primary ml-5 mt-3" v-else>{{ $store.getters.translate("nothing_found") }}</div>
  <!--UPLOAD FILES-->
  <v-row v-if="create && (multiple_files || files.length === 0)" class="ml-3 mr-3 mt-3">
    <v-col v-cloak @drop.prevent="addDropFile" @dragover.prevent>
      <v-file-input
          v-model="new_files"
          :multiple="multiple_files"
          @change="saveFiles"
          :label="$store.getters.translate('files')"
          placeholder="Drop file to upload"
          color="primary"
          bg-color="white"
          density="compact"
          hide-details
          show-size/>
    </v-col>
  </v-row>
</template>

<script>
import helpFunctions from "../../plugins/helpFunctions";
import {PhDotsThreeVertical, PhTrash} from "@phosphor-icons/vue";

export default {
  components: {PhTrash, PhDotsThreeVertical},
  props: ["page", "parent_id", "label", "files", "multiple_files", "deletable", "create", "category"],
  data() {
    return {
      new_files: [],
    };
  },
  methods: {
    async preview(file) {
      let response = await helpFunctions.postCustomRoute(this.$toast, "preview-in-new-tab", { id: file.id }, false, true);
      let fileUrl = response.url;
      window.open(fileUrl, '_blank');
    },
    async deleteFile(file) {
      this.$confirm(this.$store.getters.translate("delete_confirmation")).then(async (res) => {
        if (res) {
          if(this.page.model === 'document') {
            await helpFunctions.deleteFile(this.$toast, this.page.name, {id: this.parent_id});
          }
          else {
            await helpFunctions.deleteModel(this.$toast, "files", file.id);
            //USED AT PUNCHLIST ITEMS EDIT PAGE ONLY
            this.$emit('addLogs', file);
          }
          this.$emit('refresh');
        }
      });
    },
    addDropFile(e) {
      if(this.multiple_files) {
        this.uploadFiles(e.dataTransfer.files);
      }
      else {
        this.uploadOneFile(e.dataTransfer.files[0]);
      }
    },
    async saveFiles() {
      if(this.multiple_files && this.new_files.length > 0) {
        await this.uploadFiles(this.new_files);
      }
      else if(typeof this.new_files === "object" && this.new_files.name) {
        await this.uploadOneFile(this.new_files);
      }
    },
    async uploadFiles(files) {
      const formData = new FormData();
      for (let i = 0; i < files.length; i++) {
        formData.append("attachment[]", files[i]);
      }
      formData.append("id", this.parent_id);
      formData.append("category", this.category);
      await helpFunctions.saveFile(this.$toast, this.page.name, formData);
      this.new_files = [];
      this.$emit('refresh');
    },
    async uploadOneFile(file) {
      const formData = new FormData();
      formData.append("attachment", file);
      formData.append("id", this.parent_id);
      await helpFunctions.saveFile(this.$toast, this.page.name, formData);
      this.new_files = [];
      this.$emit('refresh');
    },
  },
};
</script>

<style scoped>
.v-toolbar-title >>> .v-toolbar-title__placeholder {
  overflow: visible !important;
}
</style>